var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKerboodleServiceMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0A20 20 0 002.77 30.15L.84 37c-.46 1.65.5 2.6 2.15 2.15l6.86-1.93A20 20 0 1020 0zm8.32 30.58h-6.38l-2.47-6.74-2.16 2.23-.64 4.5H10.8l3.26-23.32h6L18.22 19.7l5.34-6.23h6.72L23.74 20z"
  })));
}
export default SvgKerboodleServiceMark;